import {environment} from '../../../environments/environment';

export class EnvironmentConfiguration {
  /**
   * URL for accessing the Commerce API.
   */
  static commerceApiUri(): string {
    return environment.commerceApiUri;
  }

  /**
   * True or false based on variable 'enableProdMode'
   */
  static enableProdMode(): boolean {
    return environment.enableProdMode;
  }
}
